import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography from 'builder/styles/typography'
import { rotation } from 'builder/styles/keyframes'

export const SuggestionTogglerContainer = styled.div<{
  isAiAction: boolean
  isActive: boolean
}>(({ isAiAction, isActive }) => {
  return css`
    display: flex;
    align-items: center;
    ${isAiAction &&
    css`
      background-color: ${isActive ? Colors.Indigo20 : Colors.White};
      border-radius: 100px;
      &:hover {
        background-color: ${isActive ? Colors.Indigo20 : Colors.Indigo40};
      }
    `}
  `
})

export const StarIcon = styled.div`
  color: ${Colors.Indigo50};
  padding-right: 4px;
`

export const ActionText = styled.span``

export const NewBadgeActionText = styled.span`
  color: ${Colors.Indigo50};
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.3px;
`

export const ActionIcon = styled.div<{
  isActive?: boolean
  isLoading?: boolean
  isAiAction: boolean
}>(({ isLoading, isActive, isAiAction }) => {
  return css`
    margin-left: 8px;
    color: ${Colors.White};
    background-color: ${Colors.Blue50};
    border-radius: 50%;
    transition: transform 0.2s ease, color 0.2s ease, background-color 0.2s ease;
    & svg {
      display: block;
    }
    ${isLoading &&
    css`
      background-color: ${Colors.Neutral50};
      animation: ${rotation} 0.5s infinite linear;
    `}
    ${isActive &&
    css`
      transform: rotate(45deg);
      background-color: ${Colors.Neutral20};
      color: ${Colors.Neutral50};
    `}
    ${isAiAction &&
    css`
      margin-left: 4px;
      background: inherit;
      color: ${Colors.Indigo50};
    `}
  `
})

export const Action = styled.div<{
  isActive: boolean
  isDisabled?: boolean
  isAiAction: boolean
}>(({ isDisabled, isActive, isAiAction }) => {
  return css`
    display: flex;
    align-items: center;
    ${Typography.Caption};
    color: ${Colors.Neutral50};
    cursor: pointer;
    user-select: none;
    pointer-events: ${isDisabled ? 'none' : 'auto'};

    &:hover {
      ${ActionText} {
        color: ${Colors.Blue50};
      }
    }

    ${isActive &&
    css`
      ${ActionIcon} {
        transform: rotate(45deg);
        background-color: ${Colors.Neutral20};
        color: ${Colors.Neutral50};
      }
    `}

    ${isAiAction &&
    css`
      padding: 4px 4px 4px 8px;
    `}

    ${isAiAction &&
    !isActive &&
    css`
      &:hover {
        ${ActionIcon}, ${NewBadgeActionText}, ${StarIcon} {
          color: ${Colors.Indigo10};
        }
      }
    `}
      ${isActive &&
    isAiAction &&
    css`
      ${ActionIcon} {
        background-color: ${Colors.Indigo50};
        color: ${Colors.Indigo10};
      }
      ${NewBadgeActionText} {
        color: ${Colors.Indigo50};
      }
    `}
  `
})
